import styled, { css } from 'styled-components';

import { BillingTooltip } from '../../styledComponents/createProject';

export const DashboardPageHeader = styled.div`
  display: grid;
  grid-template-columns: 49% 49%;
  grid-column-gap: 2%;
  justify-content: space-between;
  align-items: center;
  @media screen and (max-width: 768px) {
    display: flex;
    width: 100%;
    justify-content: space-between;
  }
  @media screen and (max-width: 620px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;
export const TitleAndModeSelectorDiv = styled.div`
  display: flex;
  align-items: center;
`;

// date range sections
export const DateRangeContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.main.white};
  border: 1px solid ${({ theme }) => theme.colors.main.blue};
  border-radius: ${({ theme }) => theme.borderRadii.card};
  padding: 5px 10px;
  width: max-content;
  justify-self: flex-end;
  display: flex;
  justify-content: space-between;
  align-items: center;
  grid-column-gap: 10px;
  @media screen and (max-width: 768px) {
    margin-top: 20px;
  }
`;

export const DateRangeTooltip = styled.div`
  position: relative;
  border-radius: 50%;
  color: ${({ color, theme }) => color || theme.colors.main.white};

  background-color: ${({ bgColor, theme }) =>
    bgColor || theme.colors.main.blue};
  font-size: 11px;
  height: 16px;
  width: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: default;
  ${BillingTooltip} {
    display: none;
  }
  &:hover {
    ${BillingTooltip} {
      display: block;
    }
  }
`;

export const DateRangeDiv = styled.div`
  text-align: right;
  @media screen and (max-width: 768px) {
    margin-top: 15px;
    text-align: left;
  }
`;
export const DateRangeText = styled.span`
  font-size: 15px;
  color: ${({ theme }) => theme.colors.main.labelText};
`;

export const ModeSelectDiv = styled.div`
  display: flex;
  align-items: center;
  background-color: ${({ active, theme }) =>
    active ? theme.colors.main.primary : theme.colors.main.white};
  border: 1px solid
    ${({ active, theme }) =>
      active ? theme.colors.main.primary : theme.colors.main.white};
  border-radius: 6px;
  padding: 8px;
  cursor: pointer;
  &:hover {
    border-color: ${({ theme }) => theme.colors.border.primary};
  }
`;
export const ModeSelectIcon = styled.img`
  height: 12px;
  width: 12px;
  margin-right: 7px;
`;
export const ModeSelectText = styled.span`
  color: ${({ active, theme }) =>
    active ? theme.colors.main.white : theme.colors.main.textMain};
  font-size: 12px;
`;

export const DashboardPageContent = styled.div`
  margin-top: ${({ marginTop }) => marginTop || '40px'};
`;
export const DashboardPerformanceReportContainer = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.border.secondary};
  border-radius: 10px;
  background: #fff;
  box-shadow: none;
  display: grid;
  grid-template-columns: ${({ columns }) => columns || '1fr 1fr'};
  column-gap: ${({ gutter }) => gutter || '2%'};
  row-gap: 20px;
  padding: ${({ padding }) => padding || '30px'};
  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
  }
  ${({ marginTop }) =>
    marginTop &&
    css`
      margin-top: ${marginTop};
    `}
  @media screen and (max-width: 1366px) {
    grid-template-columns: ${({ laptopColumns, columns }) =>
      laptopColumns ? laptopColumns : columns ? columns : 'auto auto'};
  }
`;

export const DashboardCardContainer = styled.div`
  display: grid;
  background: ${({ background }) => background};
  padding: ${({ padding }) => padding};
  grid-template-columns: ${({ columns }) => columns || '49.5% 49.5%'};
  grid-column-gap: ${({ columnGap }) => columnGap || '1%'};
  grid-row-gap: 20px;
  ${({ marginTop }) =>
    marginTop &&
    css`
      margin-top: ${marginTop};
    `}
  @media screen and (max-width: 1366px) {
    grid-template-columns: ${({ laptopColumns, columns }) =>
      laptopColumns ? laptopColumns : columns ? columns : 'auto auto'};
  }
  @media screen and (max-width: 768px) {
    grid-template-columns: ${({ tabletColumns, laptopColumns, columns }) =>
      tabletColumns
        ? tabletColumns
        : laptopColumns
        ? laptopColumns
        : columns
        ? columns
        : 'auto auto'};
  }
  @media screen and (max-width: 500px) {
    grid-template-columns: ${({
      mobileColumns,
      tabletColumns,
      laptopColumns,
      columns,
    }) =>
      mobileColumns
        ? mobileColumns
        : tabletColumns
        ? tabletColumns
        : laptopColumns
        ? laptopColumns
        : columns
        ? columns
        : 'auto auto'};
  }
`;

export const DashboardCardsContainer = styled.div`
  display: grid;
  border: 1px solid ${({ theme }) => theme.colors.main.textMain};
  border-radius: 10px;
  background: #fff;
  padding: ${({ padding }) => padding};
  grid-template-columns: ${({ columns }) => columns || '49.5% 49.5%'};
  grid-column-gap: ${({ columnGap }) => columnGap || '1%'};
  grid-row-gap: 20px;
  ${({ marginTop }) =>
    marginTop &&
    css`
      margin-top: ${marginTop};
    `}
  @media screen and (max-width: 1366px) {
    grid-template-columns: ${({ laptopColumns, columns }) =>
      laptopColumns ? laptopColumns : columns ? columns : 'auto auto'};
  }
  @media screen and (max-width: 768px) {
    grid-template-columns: ${({ tabletColumns, laptopColumns, columns }) =>
      tabletColumns
        ? tabletColumns
        : laptopColumns
        ? laptopColumns
        : columns
        ? columns
        : 'auto auto'};
  }
  @media screen and (max-width: 500px) {
    grid-template-columns: ${({
      mobileColumns,
      tabletColumns,
      laptopColumns,
      columns,
    }) =>
      mobileColumns
        ? mobileColumns
        : tabletColumns
        ? tabletColumns
        : laptopColumns
        ? laptopColumns
        : columns
        ? columns
        : 'auto auto'};
  }
`;
export const SmallCardContainer = styled.div``;
export const SmallCardLabel = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.main.labelText};
  margin-left: 10px;
  margin-top: 10px;
  @media screen and (max-width: 1400px) {
    margin-top: 8px;
  }
`;

// text-[11px] px-2.5 py-0.5 rounded-full
export const TextBadge = styled.span`
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 12px;
  background-color: ${({ color }) => `${color}12` || 'rgba(31, 41, 55, 0.07)'};
  color: ${({ color }) => color || 'rgb(31, 41, 55)'};
  font-weight: 700;
  display: inline-block;
  white-space: nowrap;
`;

// flex gap-1 p-1 rounded-xl
export const FlexTab = styled.div`
  display: flex;
  gap: 4px;
  padding: 4px;
  border-radius: 12px;
  background-color: ${({ color }) => color || '#f3f4f6'};
  width: max-content;
`;

// Inactive Tabs
// px-4 py-1.5 rounded-lg text-[12px] transition-all
// font-weight: 400; background-color: transparent; color: rgb(156, 163, 175); box-shadow: none;
// px-4 py-1.5 rounded-lg text-[12px] transition-all
// font-weight: 600; background-color: rgb(255, 255, 255); color: rgb(79, 52, 35); box-shadow: rgba(0, 0, 0, 0.08) 0px 1px 4px;

export const TabButtons = styled.button`
  padding: 6px 16px;
  border-radius: 8px;
  font-size: 12px;
  transition: all 0.2s ease-in-out;
  cursor: pointer;
  border: none;

  ${({ active }) =>
    active
      ? css`
          font-weight: 600;
          background-color: white;
          box-shadow: rgba(0, 0, 0, 0.08) 0px 1px 4px;
          color: #4f3423;
        `
      : css`
          font-weight: 400;
          background-color: transparent;
          box-shadow: none;
          color: #9ca3af;
        `}

  &:hover {
    background-color: gainsboro;
    color: ${({ theme }) => theme.colors.main.white};
  }
`;

// h-6 w-px
// background-color: rgb(229, 231, 235);
export const VerticalBar = styled.div`
  height: 24px;
  width: 1px;
  background-color: #e5e7eb;

`
